import { usePagination, DOTS } from "./usePagination";
import ellipsis from "../../assets/ellipsis.svg";
import "./styles.scss";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className={`pagination-container  ${className ? className : ""}`}>
      {/* Left navigation arrow */}
      <li
        className={`pagination-item pagination-item-left
          ${currentPage === 1 ? "disabled" : ""}`}
        onClick={onPrevious}
        tabIndex={currentPage !== 1 ? 0 : -1}
        onKeyDown={(event) => {
          currentPage !== 1 && event.keyCode === 13 && onPrevious();
        }}
      >
        <div
          className={`arrow arrow-left ${
            currentPage === 1 ? "arrow-disabled" : ""
          }`}
        />
      </li>
      {paginationRange.map((pageNumber) => {
        // If the pageItem is a DOT, render the DOTS unicode character
        if (pageNumber === DOTS) {
          return (
            <li className="pagination-item dots">
              <img src={ellipsis} alt="elipssis" />
            </li>
          );
        }

        // Render our Page Pills
        return (
          <li
            className={`pagination-item   ${
              pageNumber === currentPage ? "selected" : ""
            }`}
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            tabIndex={0}
            onKeyDown={(event) => {
              event.keyCode === 13 && onPageChange(pageNumber);
            }}
          >
            {pageNumber}
          </li>
        );
      })}
      {/*  Right Navigation arrow */}
      <li
        className={`pagination-item pagination-item-right
          ${currentPage === lastPage ? "disabled" : ""}`}
        onClick={onNext}
        tabIndex={currentPage !== lastPage ? 0 : -1}
        onKeyDown={(event) => {
          currentPage !== lastPage && event.keyCode === 13 && onNext();
        }}
      >
        <div
          className={`arrow arrow-right ${
            currentPage === lastPage ? "arrow-disabled" : ""
          }`}
        />
      </li>
    </ul>
  );
};

export default Pagination;
